import { render, staticRenderFns } from "./ProductsTableMobile.vue?vue&type=template&id=0e3cf1d1&scoped=true"
import script from "./ProductsTableMobile.vue?vue&type=script&lang=js"
export * from "./ProductsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3cf1d1",
  null
  
)

export default component.exports